export const HomePageButtonLabel = "Get Started";
export const HomePageTitle = "Welcome to the RUSH";
export const HomePageTitleLong = "Welcome to the RUSH Initiative Web Map";
export const HomePageSubTitle =
  "Climate change is a real bummer but reversing the trend is at our fingertips and in our footprints. The Resilient Urban Systems & Habitat (RUSH) Initiative is about rapid resilience in record time.";
export const HomePageBody = [
  "Join this collective creation to mapping the difference we’re all making. Comparing datasets on personal and planetary health. Help us plot the spots that track the healing. Help identify the risks and the fixes.",
  "The RUSH Initiative is exploring this work on the unceded and unsurrendered territories of the lək̓ʷəŋən and SENĆOŦEN speaking peoples. Maps have a long history of erasure of Indigenous cultures and territories. Our goal is to promote tools that support the healing of ecosystems and communities so that all beings can live their best life.",
];
export const HomePageQuote =
  "Choose a question. Consider the data. Find the people and solutions that werk for you.";

export const AboutPageText = [
  {
    type: "p",
    content:
      "The RUSH Initiative is exploring this work on the unceded and unsurrendered territories of the lək̓ʷəŋən and SENĆOŦEN speaking peoples. Maps have a long history of erasure of Indigenous cultures and territories. Our goal is to promote tools that support the healing of ecosystems and communities as a way to practice reconciliation, gratitude, and respect.",
  },
  {
    type: "p",
    content:
      "By showcasing the research, creativity, and innovation happening in this region on an interactive landing page, we hope to provide a shared language on the vulnerabilities and opportunities for long-term health and climate action.",
  },
  {
    type: "p",
    content:
      "We want to change the critical questions that get asked in planning meetings.  How is a development proposal an opportunity to increase resilience to climate-related events? How can we support neighbourhoods to adapt and thrive in changing conditions? If we extend and connect the ecosystem features across the urban landscape, what are all the benefits people would feel? How can we work with Nature to create a quality of life for all?",
  },
  {
    type: "p",
    content:
      "This is a tool for people to connect habitats, restore watersheds, feel a sense of belonging, and start conversations that lead to a brighter future.  Please use the feedback button to let us know what you think and any suggestions you have.",
  },
];

export const TutorialPopupQuote = "Pick a topic from the left to start exploring the map!";

export const LegendGroups = {
  StartOn: { group: "Starting Place", position: 0, subheading: undefined },
  StartOff: { group: "Deeper Connections", position: 1, subheading: undefined },
  OGM: {
    group: "Plot that Spot",
    position: 9999,
    subheading:
      "Connect the call to action by joining these community mapping projects powered by OpenGreenMap.",
  },
  NatureHood: {
    group: "NatureHood in the City",
    link: "https://www.gvnaturehood.com/greater-victoria-naturehood-map",
    subheading:
      "One Map, One NatureHood, A Guide to Many Adventures. Provided by Greater Victoria NatureHood. 🕊️ Leave no trace 🕊️ Leave what you find 🕊️ Respect wildlife 🕊️ Be mindful of others",
  },
  Trees: { group: "Trees", position: 0, subheading: undefined },
  G4A: { group: "Greenspace for All", position: 2, subheading: undefined },
  Landcover: { group: "Landcover", position: 3, subheading: undefined },
  Community: { group: "Community", position: 4, subheading: undefined },
};

export const InitiativeTags = {
  StoryMap: "StoryMap",
  Report: "Report",
  Organization: "Organization",
  Business: "Business",
  Indigenous: "Indigenous",
  Map: "Map",
  Agreement: "Agreement",
  Target: "Target",
  Initiative: "Initiative",
  Program: "Program",
  Portal: "Info Portal",
  Funding: "Funding",
  Government: "Government",
  Video: "Video",
  Infographic: "Infographic",
};

export const InitiativeTagColors = {
  Organization: "blue",
  Business: "blue",
  Initiative: "cyan",
  Program: "cyan",
  Government: "red",
  Indigenous: "orange",
  Funding: "green",
  Report: "gray",
  Agreement: "teal",
  Target: "red",
  StoryMap: "purple",
  Map: "purple",
  Video: "pink",
  Infographic: "yellow",
  "Info Portal": "yellow",
};
